import { useSuspenseQuery } from '@apollo/client';

import { PageError } from '@xing-com/crate-entity-pages-entity-pages-shared-components-page-error';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EntitySubpageModuleDocument } from '../../graphql/queries/entity-subpage-module.gql-types';

type Props = {
  children: (moduleGlobalId?: string) => React.ReactNode;
  moduleType: string;
};
export const SubpageModule: React.FC<Props> = ({ children, moduleType }) => {
  const { pageContext } = usePageContext();
  const { data, error } = useSuspenseQuery(EntitySubpageModuleDocument, {
    variables: {
      id: pageContext.pageSlug,
      moduleType: moduleType,
    },
  });

  const moduleProperties = data?.moduleProperties;

  if (error || !moduleProperties) {
    return <PageError type={404} />;
  }

  const moduleGlobalId =
    moduleProperties?.__typename === 'EntityPageGenericModule'
      ? (moduleProperties.globalId ?? undefined)
      : undefined;

  return children(moduleGlobalId);
};
